import { createContext, useContext } from 'react';
import type { MeDto, Permission } from '@app/shared';

export type ThemeMode = 'auto' | 'light' | 'dark';

/** Экраны поверх вкладок (полноэкранные или вложенные). */
export type Route =
  | { name: 'viewer'; panelId: string }
  | { name: 'staff' }
  | { name: 'equipment'; panelId?: string }
  | { name: 'sessions'; panelId?: string }
  /** Страница единицы оборудования: по id или по ключу QR-кода (отсканировали код). Без обоих — новая. */
  | { name: 'unit'; id?: string; qr?: string }
  /** Проверка по списку действий: пройти или посмотреть результат. */
  | { name: 'check'; id: string }
  /** Номенклатура: список (загрузка из Excel) и карточка. */
  | { name: 'products' }
  | { name: 'product'; id: string }
  /** Библиотека типовых действий. */
  | { name: 'actions' }
  /** Загрузка таблиц: номенклатура, остатки, план, факт. */
  | { name: 'imports' };

export interface AppCtx {
  me: MeDto;
  can(p: Permission): boolean;
  reloadMe(): Promise<void>;
  toast(text: string): void;
  /** Общая обработка ошибок API: текст из ответа сервера — в тост. */
  fail(e: unknown): void;
  open(r: Route): void;
  close(): void;
  themeMode: ThemeMode;
  setThemeMode(m: ThemeMode): void;
}

export const Ctx = createContext<AppCtx | null>(null);

export function useApp(): AppCtx {
  const c = useContext(Ctx);
  if (!c) throw new Error('AppCtx is missing');
  return c;
}

export function loadThemeMode(): ThemeMode {
  try {
    const v = localStorage.getItem('theme');
    if (v === 'light' || v === 'dark' || v === 'auto') return v;
  } catch {
    /* нет хранилища */
  }
  return 'auto';
}

export function saveThemeMode(m: ThemeMode) {
  try {
    localStorage.setItem('theme', m);
  } catch {
    /* нет хранилища */
  }
}
